import * as React from 'react';

function SvgLandlordNoProperty(props) {
  return (
    <svg viewBox="0 0 212 172" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.926 165.635c6.071 6.077 17.582 3.644 24.793-1.82 6.222-4.716 10.602-12.552 16.945-17.043 10.615-7.513 24.397-4.156 36.211 1.58 8.359 4.058 17.515 9.283 25.66 5.537 5.732-2.637 9.592-9.348 11.623-16.523.98-3.464 1.667-7.223 3.62-9.935 1.162-1.612 2.696-2.735 4.275-3.674 14.403-8.574 32.93-3.215 46.895-12.782 9.427-6.46 15.295-18.998 17.733-32.178 2.438-13.18 1.835-27.094.864-40.77-.691-9.719-1.782-20.104-6.922-27.741A23.062 23.062 0 00177.929.267c-8.148 1.265-15.452 6.41-21.842 12.55-7.993 7.661-15.347 17.28-25.287 20.188-6.771 1.98-13.964.579-21.003-.04-11.766-1.034-23.49.156-35.143 1.5-11.154 1.286-22.386 2.722-32.951 6.938-7.476 2.984-30.452 14.143-38.065 31.9-1.815 4.233-12.822 64.197 15.288 92.332z"
        fill="#E2F4F2"
      />
      <ellipse cx={49.343} cy={101.628} rx={18.696} ry={24.855} fill="#8BD0C9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.343 94.172c-.688 0-1.246.759-1.246 1.694v6.19l-4.211-3.472c-.6-.494-1.407-.29-1.805.455-.397.745-.233 1.75.366 2.244l5.65 4.658v46.188c0 .935.558 1.694 1.246 1.694s1.246-.759 1.246-1.694V95.866c0-.935-.558-1.694-1.246-1.694z"
        fill="#90B6B0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.49 155.065s-6.961-26.097-19.728-26.097c-12.767 0-8.178 15.975-13.667 17.31-5.488 1.335-6.256-10.637-13.763-10.637-7.508 0-12.671 9.8-12.671 19.424h59.828z"
        fill="#8BD0C9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.292 97.233l-37.495 22.363v7.984h4.018v18.043h-4.018v16.064h37.495V97.233z"
        fill="#D9D9D9"
      />
      <path fill="#fff" fillOpacity={0.461} d="M58.848 125.593h20.687v20.625H58.848z" />
      <path
        fill="#E6E3D8"
        d="M49.797 127.526h4.008v18.176h-4.008zm140.672.645h4.137v18.176h-4.137z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.414 90.787v8.885l-33.617 19.475v-7.368l33.617-20.992z"
        fill="#63656A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M155.818 99.81l38.788 21.469v7.665h-4.156v17.322h4.156v15.421h-38.788V99.811z"
        fill="#D9D9D9"
      />
      <path fill="#fff" fillOpacity={0.461} d="M184.262 128.171h-20.687v19.336h20.687z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159.697 94.654v8.481l34.909 18.59v-7.033l-34.909-20.038z"
        fill="#63656A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.988 15.88l-37.24 29.37v117.273h76.033V45.249L116.988 15.88z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M132.611 159.874H99.063v-25.14c0-8.835 7.51-15.998 16.774-15.998 9.264 0 16.774 7.163 16.774 15.998v25.14z"
        fill="#FCCD00"
      />
      <ellipse cx={125.156} cy={143.045} rx={2.33} ry={2.337} fill="#4C4C4C" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160 58.9V46.465l-42.446-34.313L75.5 45.32v12.946l42.035-33.152L159.637 58.9H160z"
        fill="#63656A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.099 71.6h12.272v-7.09h-12.272v7.09zm0-10.83h12.272v-7.48h-12.272v7.48zm-3.728-7.48v7.48h-13.047v-7.48h13.047zm0 11.22v7.09h-13.047v-7.09h13.047zm3.728 38.879h12.272v-7.091h-12.272v7.091zm0-10.831h12.272v-7.48h-12.272v7.48zm-3.728-7.48v7.48h-13.047v-7.48h13.047zm0 11.22v7.091h-13.047v-7.091h13.047z"
        fill="#FCCD00"
      />
      <rect
        x={167.946}
        y={128.919}
        width={6.365}
        height={32.327}
        rx={3.183}
        transform="rotate(-28 167.946 128.919)"
        fill="#63656A"
      />
      <ellipse
        cx={156.689}
        cy={104.357}
        rx={25.461}
        ry={25.385}
        transform="rotate(-28 156.689 104.357)"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M186.785 112.772l-58.29.096.004-4.581 55.706-.096-.004 4.584m2.571 10.351l-53.121.105.004-4.571 45.369-.093-.004 4.568m-30.418 10.447l.004-4.594 14.5-.032-.005 4.596-14.499.03z"
        fill="#EBE9E5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M142.921 104.42c9.561 0 17.311-7.737 17.311-17.282a17.18 17.18 0 00-3.101-9.872 27.089 27.089 0 00-13.151 3.189c-7.386 3.927-12.222 10.77-13.835 18.345a17.278 17.278 0 0012.776 5.62z"
        fill="#38B2A6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M134.592 85.712l7.72-6.968c.346-.329.865-.33 1.23-.001l3.821 3.444.001-.616c0-.226.174-.41.385-.411l1.058-.001c.21 0 .384.184.384.41l-.003 2.278 2.056 1.844c.403.37.441 1.005.113 1.416-.347.432-.943.474-1.327.125l-.115-.102-.01 8.004c-.001.349-.27.637-.596.637l-4.404.006.009-7.41-3.96.005-.009 7.41-4.404.005c-.326 0-.595-.287-.595-.635l.01-8.005-.115.102a.908.908 0 01-.616.247.964.964 0 01-.73-.347c-.346-.45-.288-1.088.097-1.437"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M171.213 131.674c15.132-8.045 20.896-26.798 12.874-41.885-8.022-15.086-26.791-20.794-41.923-12.749-15.131 8.046-20.895 26.799-12.873 41.885 8.021 15.087 26.791 20.795 41.922 12.749zm-2.607-4.903c12.416-6.601 17.145-21.988 10.563-34.367-6.581-12.379-21.982-17.062-34.398-10.46-12.416 6.601-17.145 21.988-10.563 34.367 6.582 12.378 21.983 17.062 34.398 10.46z"
        fill="#63656A"
      />
    </svg>
  );
}

export default SvgLandlordNoProperty;
